import React, { useState, useEffect } from 'react';

import Header from './components/Header/Header';
import Navigation from './components/Navbar/Navigation';
import Main from './components/Main/Main';
import Footer from './components/Footer/Footer';
import Loader from './components/Loader/Loader';

import 'bootstrap/dist/css/bootstrap.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import services from './data/services.json';

import './App.css';

function App() {
  const [loading, setLoading] = useState(true);
  const [afterBooking, setAfterBooking] = useState(false);
  const [dataAfter, setDataAfter] = useState(null);
  const [courseClass, setCourseClass] = useState('');

  const changeAfterBooking = (selectedData, email, name) => {
    setDataAfter({ selected: selectedData, email, name });
    setAfterBooking((prevState) => !prevState);
  };

  useEffect(() => {
    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);

    const courseClass = urlParams.get('courseClass');
    if (courseClass) {
      setCourseClass(courseClass);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <ToastContainer />
      <div className="app-container">
        <Navigation />
        <div className="container">
          {!afterBooking ? (
            <>
              <Header />
              <Main
                data={services}
                bookDone={changeAfterBooking}
                courseClass={courseClass}
              />
            </>
          ) : (
            <div className="feedBack shadow-lg p-5 mb-5 bg-body rounded">
              <i
                className="fas fa-check-circle mb-1"
                style={{ fontSize: '2rem', color: '#198754' }}
              ></i>
              <div className="mb-3">
                Thank you for submitting your details. You will shortly receive
                an email with instructions on how to complete the payment for
                your booking fee. Please note that only upon completion of the
                payment of the booking fee your place will be secured.
              </div>

              <ul className="list-group">
                <li className="list-group-item">
                  <i
                    className="far fa-calendar-alt me-2"
                    style={{ display: '' }}
                  ></i>{' '}
                  {`${dataAfter?.selected?.date.split(',')[0]}  ${
                    dataAfter?.selected?.date.split(',')[1]
                  }`}
                  <br />
                  <i className="fas fa-user-circle"></i>{' '}
                </li>
              </ul>
              <div className="form-text mt-2">
                <br></br>Thank you, {dataAfter?.name}!
              </div>
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="mt-3 btn btn-primary btn-sm"
              >
                <i className="fas fa-redo-alt text-white me-2"></i> Back to home
                page
              </button>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default App;
